import { ProductInspectionSampleDto } from "libs/shared-models/production-management/src/lib/product-inspection/product-inspection-samples.dto";
import { EntityRepository, Repository } from "typeorm";
import { FgInspectionSamples } from "../entities/fg-inspection-samples.entity";

@EntityRepository(FgInspectionSamples)
export class FgInspectionSamplesRepository extends Repository<FgInspectionSamples> {

}